import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AppShell, bindShellUser } from '@/app/shell';
import { foldersQuery, sectionsQuery } from '@/features/constructor/api';
import { SectionSidebar } from '@/features/constructor/viewer/SectionSidebar';
import { SectionViewerPage } from '@/features/constructor/viewer/SectionViewerPage';

/**
 * Section viewer (590:16362): `/t/:tenant/s/:sectionId?f=:folderId`. Outside the `_shell` layout — it brings its own
 * shell with the flat section list ("Site bar full") instead of the module tree.
 */
export const Route = createFileRoute('/_authed/t/$tenantSlug/s/$sectionId')({
  validateSearch: z.object({ f: z.string().optional() }),
  beforeLoad: ({ context }) => bindShellUser(context.me.user.id),
  loader: ({ context, params }) => {
    void context.queryClient.prefetchQuery(sectionsQuery(context.tenant.id));
    void context.queryClient.prefetchQuery(foldersQuery(context.tenant.id, params.sectionId));
  },
  component: SectionViewerRoute,
});

function SectionViewerRoute() {
  const { tenant } = Route.useRouteContext();
  const { sectionId } = Route.useParams();
  const { f } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <AppShell tenant={tenant} sidebar={<SectionSidebar tenant={tenant} activeSectionId={sectionId} />}>
      <SectionViewerPage
        tenant={tenant}
        sectionId={sectionId}
        folderId={f}
        onFolderChange={(folderId) => void navigate({ search: { f: folderId }, replace: true })}
      />
    </AppShell>
  );
}
